import { exchangeConstants, alertConstants } from '../_constants'
import { exchangeService,companyService} from '../_services'
import { alertActions } from './'

export const exchangeActions = {
  addExchange,
  getExchange,
  getExchangeById,
  getExchangeByPage,
  updateExchange,
  deleteExchange,
  getZeroValueCompanyByExchange,
  deleteZeroValueCompanyByExchange,
  clearAllMessages
}

function getZeroValueCompanyByExchange(exchangeId) {
  return dispatch => {
    dispatch(request(exchangeId))
    companyService.getZeroMarketCompanyByExchange(exchangeId)
      .then(
        exchange => {
          console.log(exchange)
          dispatch(success(exchange))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.GET_ZERO_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.GET_ZERO_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.GET_ZERO_FAILURE, error } }
}

function deleteZeroValueCompanyByExchange(exchangeId) {
  return dispatch => {
    dispatch(request(exchangeId))

    companyService.deleteZeroMarketCompanyByExchange(exchangeId)
      .then(
        exchange => {
          console.log(exchange)
          dispatch(success(exchange))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.DELETE_ZERO_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.DELETE_ZERO_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.DELETE_ZERO_FAILURE, error } }
}

function addExchange(exchange) {
  return dispatch => {
    dispatch(request(exchange))

    exchangeService.addExchange(exchange)
      .then(
        exchange => {
          console.log(exchange)
          dispatch(success(exchange))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.ADD_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.ADD_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.ADD_FAILURE, error } }
}

function getExchange(exchange) {
  return dispatch => {
    dispatch(request(exchange))

    exchangeService.getExchange(exchange)
      .then(
        exchange => {
          console.log(exchange)
          dispatch(success(exchange))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.GETALL_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.GETALL_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.GETALL_FAILURE, error } }
}

function getExchangeByPage(start,pageSize,search) {
  return dispatch => {
    dispatch(request())
    exchangeService.getExchangeByPage(start,pageSize,search)
      .then(
        exchange => {
          console.log('exchange' + exchange)
          if(exchange.data)
            dispatch(success(exchange))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.GETALL_PAGE_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.GETALL_PAGE_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.GETALL_PAGE_FAILURE, error } }
}
function deleteExchange(id,userId) {
  return dispatch => {
    dispatch(request(id,userId))
    exchangeService.deleteExchange(id,userId)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
          dispatch(getExchangeByPage(0,20,''))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: exchangeConstants.DELETE_REQUEST, response } }
  function success(response) { return { type: exchangeConstants.DELETE_SUCCESS, response } }
  function failure(error) { return { type: exchangeConstants.DELETE_FAILURE, error } }
}
function getExchangeById(id) {
  return dispatch => {
    dispatch(request())

    exchangeService.getExchangeById(id)
      .then(
        exchange => {
          console.log(exchange)
          dispatch(success(exchange))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.GETBYID_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.GETBYID_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.GETBYID_FAILURE, error } }
}
function updateExchange(exchange,id) {
  return dispatch => {
    dispatch(request(exchange))
    exchangeService.updateExchange(exchange,id)
      .then(
        exchange => {
          console.log('exchange' + exchange)
          if(exchange.message)
            dispatch(success(exchange))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(exchange) { return { type: exchangeConstants.UPDATE_REQUEST, exchange } }
  function success(exchange) { return { type: exchangeConstants.UPDATE_SUCCESS, exchange } }
  function failure(error) { return { type: exchangeConstants.UPDATE_FAILURE, error } }
}
function clearAllMessages()
{
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}
